import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { environment } from "src/environments/environment";
import { ApiErrorHandlerService } from "./api-error-handler.service";
import { ParametroNovaAnotacao } from "../model/parametro-nova-anotacao.model";
import { Observable, catchError } from "rxjs";
import { Retorno } from "../model/retorno.model";
import { Anotacao } from "../model/anotacao.model";
import { ParametroDesfazerAnotacoesPassivas } from "../model/desfazimento-anotacoes-passivas.model";

@Injectable({
    providedIn: 'root'
})
export class AnotacaoService {

    private baseUrl = `${environment.apiUrl}/anotacao`;

    constructor(
        private http: HttpClient,
        private errorHandler: ApiErrorHandlerService
    ) { }

    anotar(parametro: ParametroNovaAnotacao): Observable<Retorno> {
        const url = `${this.baseUrl}/novo`;

        const formData = new FormData();
        formData.append('parametros', new Blob([JSON.stringify(parametro)], { type: "application/json" }));

        return this.http.post<Retorno>(url, formData).pipe(catchError(this.errorHandler.handle()));
    }

    alterarDataInicioVigencia(idAnotacao: number, dataInicioVigencia: string): Observable<Retorno> {
        const url = `${this.baseUrl}/${idAnotacao}/inicioVigencia/${dataInicioVigencia}`;

        const formData = new FormData();

        return this.http.post<Retorno>(url, formData).pipe(catchError(this.errorHandler.handle()));
    }

    buscarAnotacoesDoAto(idAto: number): Observable<Anotacao[]> {
        const url = `${this.baseUrl}/ato/${idAto}/anotacoes`;
        return this.http.get<Anotacao>(url).pipe(catchError(this.errorHandler.handle()));
    }

    desfazerAnotacao(id: number): Observable<Retorno> {
        const url = `${this.baseUrl}/${id}`;
        return this.http.delete<number>(url).pipe(catchError(this.errorHandler.handle()));
    }

    desfazerAnotacoesPassivas(parametroDesfazerAnotacoes: ParametroDesfazerAnotacoesPassivas): Observable<Retorno> {
        const url = `${this.baseUrl}/desfazerAnotacoesPassivas`;

        return this.http.delete<number[]>(url, {
            body: parametroDesfazerAnotacoes
        }).pipe(catchError(this.errorHandler.handle()));
    }
}